import { PROJECT_ENDPOINTS } from './project';
import { SCHEDULE_ENDPOINTS } from './schedule';
import { MILESTONE_ENDPOINTS } from './milestone';
import { ALERT_ENDPOINTS } from './alert';
import { DASHBOARD_ENDPOINTS } from './dashboard';
import { CALENDAR_ENDPOINTS } from './calendar';
import { PERMISSION_ENDPOINTS } from './permission';
import { MONITOR_ENDPOINTS } from './monitor';
import { SHARED_ENDPOINTS } from './shared';
import { OPPORTUNITY_ENDPOINTS } from './opportunity';

export const API_ENDPOINTS = {
  ...PROJECT_ENDPOINTS,
  ...SCHEDULE_ENDPOINTS,
  ...MILESTONE_ENDPOINTS,
  ...ALERT_ENDPOINTS,
  ...DASHBOARD_ENDPOINTS,
  ...CALENDAR_ENDPOINTS,
  ...PERMISSION_ENDPOINTS,
  ...MONITOR_ENDPOINTS,
  ...SHARED_ENDPOINTS,
  ...OPPORTUNITY_ENDPOINTS,
};

export const APP_ROUTES = {
  CALLBACK_PATH: '/callback',
};
